const faqs = [
  {
    q: "Cosa serve per l'analisi preliminare?",
    a: "È sufficiente una copia o foto leggibile dell'ultimo estratto conto POS con il dettaglio delle transazioni.",
    testid: "faq-1",
  },
  {
    q: "Ci sono vincoli o costi di recesso?",
    a: "La consulenza è completamente priva di impegni. Le soluzioni SumUp si distinguono per flessibilità e assenza di vincoli capestro.",
    testid: "faq-2",
  },
  {
    q: "Devo cambiare subito il mio POS?",
    a: "No. Prima valuti dati, risparmio e servizio con calma. La decisione resta interamente tua.",
    testid: "faq-3",
  },
  {
    q: "Lavori solo in alcune zone?",
    a: "Seguo attività in tutta Italia, anche completamente da remoto: l'analisi dell'estratto conto avviene via WhatsApp o telefono.",
    testid: "faq-4",
  },
];

export function Faq() {
  return (
    <section id="chiarimenti" data-testid="faq-section" className="py-20 px-6 max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-normal text-[#1B4D3E]">Chiarimenti Utili</h2>
      </div>
      <div className="space-y-4 font-sans text-sm">
        {faqs.map((f) => (
          <div key={f.testid} data-testid={f.testid} className="p-6 bg-white border border-[#E3DFD7]">
            <h3 className="font-bold text-[#1B4D3E] mb-2 font-editorial text-lg">{f.q}</h3>
            <p className="text-[#5A564F]">{f.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
